export const ADMIN_SYSTEM_OPTIONS = [
  { label: 'Administrador Unico', value: 'ADMINISTRADOR_UNICO' },
  { label: 'Administradores Solidarios', value: 'ADMINISTRADORES_SOLIDARIOS' },
  { label: 'Administradores Mancomunados', value: 'ADMINISTRADORES_MANCOMUNADOS' },
  { label: 'Consejo de Administracion', value: 'CONSEJO_DE_ADMINISTRACION' },
  { label: 'Patronato', value: 'PATRONATO' },
  { label: 'Asamblea', value: 'ASAMBLEA' },
  { label: 'Otros', value: 'OTROS' },
];

export const CARGO_OPTIONS = [
  { label: 'Presidente', value: 'PRESIDENTE' },
  { label: 'Vicepresidente', value: 'VICEPRESIDENTE' },
  { label: 'Secretario Consejero', value: 'SECRETARIO_CONSEJERO' },
  { label: 'Secretario no consejero', value: 'SECRETARIO_NO_CONSEJERO' },
  { label: 'Vocal', value: 'VOCAL' },
];

export const RETRIBUTION_KEY_OPTIONS = [
  { label: 'A (Rendimiento del trabajo por cuenta ajena)', value: 'A' },
  { label: 'E (Retribucion a consejero y administrador)', value: 'E' },
  { label: 'G (Rendimientos por actividades profesionales)', value: 'G' },
];

const ADMINISTRATOR_SYSTEM_TYPES = new Set([
  'ADMINISTRADOR_UNICO',
  'ADMINISTRADORES_SOLIDARIOS',
  'ADMINISTRADORES_MANCOMUNADOS',
]);

const CLASSIFICATION_LABELS: Record<string, string> = {
  general: 'Régimen General',
  autonomos: 'Régimen Especial Autónomos',
  GENERAL: 'Régimen General',
  SELF_EMPLOYED: 'Régimen Especial Autónomos',
};

const CHARGED_TO_LABELS: Record<string, string> = {
  empresa: 'Empresa',
  persona: 'Persona',
  COMPANY: 'Empresa',
  PERSON: 'Persona',
};

export function formatAdminSystemLabel(value: string | null | undefined): string {
  if (!value) return '';
  const opt = ADMIN_SYSTEM_OPTIONS.find(o => o.value === value);
  return opt?.label ?? value;
}

export function formatCargoLabel(
  cargo: string | null | undefined,
  administrationSystem: string | null | undefined,
): string {
  if (administrationSystem && ADMINISTRATOR_SYSTEM_TYPES.has(administrationSystem)) {
    return formatAdminSystemLabel(administrationSystem);
  }
  const opt = CARGO_OPTIONS.find(c => c.value === cargo);
  return opt?.label ?? (cargo || '');
}

export function formatClassificationLabel(value: string | null | undefined): string {
  if (!value) return '';
  return CLASSIFICATION_LABELS[value] ?? value;
}

export function formatSelfEmployedChargedToLabel(value: string | null | undefined): string {
  if (!value) return '';
  return CHARGED_TO_LABELS[value] ?? value;
}

export function formatRetributionKeyLabels(keys: string[] | null | undefined): string[] {
  if (!keys?.length) return [];
  return keys.map(k => {
    const opt = RETRIBUTION_KEY_OPTIONS.find(o => o.value === k);
    return opt?.label ?? k;
  });
}

export function shouldShowCargoSection(administrationSystem: string | null | undefined): boolean {
  return !!administrationSystem;
}

export function shouldShowCargoDropdown(administrationSystem: string | null | undefined): boolean {
  if (!administrationSystem) return false;
  return !ADMINISTRATOR_SYSTEM_TYPES.has(administrationSystem);
}

export function formatYesNo(value: boolean | null | undefined): string {
  return value ? 'Sí' : 'No';
}
